import { getMissingStatus } from "../services/apiMissingReport";
import { hasAllQueryValues, useMappedQuery } from "./queryUtils";

export function useStatusMissing({ start_date, end_date }) {
  return useMappedQuery({
    queryKey: ["status-missing", start_date, end_date],
    queryFn: () => getMissingStatus({ start_date, end_date }),
    enabled: hasAllQueryValues(start_date, end_date),
    dataKey: "statusMissing",
  });
}
